import graphql from "babel-plugin-relay/macro";

const labelCreateMutation = graphql`
  mutation labelCreateMutation($id: ID!, $labels: [ID]) {
    recipeLabelCreate(input: { recipe: $id, labels: $labels }) {
      recipeLabels {
        id
      }
    }
  }
`;

export default labelCreateMutation;
